export default [
  {
    header: 'Charts & Maps',
  },
  {
    title: 'Charts',
    icon: 'PieChartIcon',
    tag: '2',
    tagVariant: 'light-danger',
    children: [
      {
        title: 'Apex Chart',
        route: 'charts-apex-chart',
      },
      {
        title: 'Chart JS',
        route: 'charts-chartjs',
      },
    ],
  },
  {
    title: 'Maps',
    route: 'maps-leaflet',
    icon: 'MapIcon',
  },
]
